import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'

const propTypes = {
  type: PropTypes.string.isRequired,
}

function MembershipTypeDisplay({ type }) {
  if (!type) return null

  const membershipType = type.includes('Membership')
    ? type
    : `${type} Membership`

  return <h3>{membershipType}</h3>
}

MembershipTypeDisplay.propTypes = exact(propTypes)

export default pure(MembershipTypeDisplay)
